module.exports = __webpack_public_path__ + "static/media/panosta-background.1f333ca1.svg";